<template>
  <transition name="transition-fade" v-if="visible">
    <div class="loading-square-jelly-mask" :style="{ 'background-color': opt.mask_bgcolor }">
      <div class="loading-square-jelly-box" :style="{ 'color': opt.square_color }">
        <div></div>
        <div :style="{ 'background': opt.square_shadow_color, 'opacity': opt.square_shadow_opacity }"></div>
      </div>
      <div class="loading-text" v-if="opt.loading_text" :style="{ 'color': opt.text_color }">{{opt.loading_text}}</div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Loading",
  data() {
    return {
      visible: false,
      opt: {
        mask_bgcolor: "#f3f4f6", //遮罩层颜色
        loading_text: "", //提示文字，如不设置则不展示提示文字信息
        text_color: "#999999", //提示文字颜色，默认为 #999999
        square_color: "#abc0e7", //加载方块颜色，默认为 #abc0e7
        square_shadow_color: "#3b73d7", //加载方块阴影颜色，默认为 #3b73d7
        square_shadow_opacity: 0.15, //加载方块阴影透明度 0~1，默认为 0.15
      },
    };
  },
  mounted() {},
  methods: {
    fnShow(options) {
      if (typeof options === "string") {
        options = { loading_text: options };
      } else if (typeof options !== "object" || options === null) {
        options = {};
      }

      let _opt = Object.assign(this.opt, options);

      this.opt = _opt;

      this.visible = true;
    },
    fnClose() {
      this.opt = this.$options.data.call(this).opt;
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.loading-square-jelly-mask {
  user-select: none;
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  z-index: 190;
  display: flex;
  background-color: #f3f4f6; /* 遮罩层背景色可配置 */
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .loading-square-jelly-box,
  .loading-square-jelly-box > div {
    position: relative;
    box-sizing: border-box;
  }
  .loading-square-jelly-box {
    display: block;
    font-size: 0;
    color: #abc0e7; /* 方形颜色可配置 */
    width: 42px; /* 方形大小可配置 */
    height: 42px; /* 方形大小可配置 */
    margin-top: -0px; /* 方形大小向上偏移量可配置 */
  }
  .loading-square-jelly-box > div {
    display: inline-block;
    float: none;
    background-color: currentColor;
    border: 0 solid currentColor;
  }
  .loading-square-jelly-box > div:nth-child(1),
  .loading-square-jelly-box > div:nth-child(2) {
    position: absolute;
    left: 0;
    width: 100%;
  }
  .loading-square-jelly-box > div:nth-child(1) {
    top: -25%;
    z-index: 1;
    height: 100%;
    border-radius: 10%;
    animation: square-jelly-box-animate 0.6s -0.1s linear infinite;
  }
  .loading-square-jelly-box > div:nth-child(2) {
    bottom: -9%;
    height: 10%;
    border-radius: 50%;
    background: #3b73d7; /* 阴影颜色可配置 */
    opacity: 0.15; /* 阴影透明度可配置 */
    animation: square-jelly-box-shadow 0.6s -0.1s linear infinite;
  }
  .loading-text {
    text-align: center;
    color: #999999; /* 提示文字颜色可配置 */
    font-size: 13px; /* 提示文字大小可配置 */
    letter-spacing: 1px;
    line-height: 1.5;
    margin-top: 15px;
    width: 100%;
    overflow-wrap: break-word;
  }
}

/*
 * Animations
 */
@keyframes square-jelly-box-animate {
  17% {
    border-bottom-right-radius: 10%;
  }
  25% {
    transform: translateY(25%) rotate(22.5deg);
  }
  50% {
    border-bottom-right-radius: 100%;
    transform: translateY(50%) scale(1, 0.9) rotate(45deg);
  }
  75% {
    transform: translateY(25%) rotate(67.5deg);
  }
  100% {
    transform: translateY(0) rotate(90deg);
  }
}

@keyframes square-jelly-box-shadow {
  50% {
    transform: scale(1.25, 1);
  }
}

/* >= 801 視爲稍大點的平板或電腦屏幕（自定） */
@media (min-width: 501px) {
  .loading-square-jelly-mask {
    .loading-square-jelly-box {
      display: block;
      font-size: 0;
      color: #abc0e7; /* 方形颜色可配置 */
      width: 42px; /* 方形大小可配置 */
      height: 42px; /* 方形大小可配置 */
      margin-top: -0px; /* 方形大小向上偏移量可配置 */
    }
    .loading-text {
      text-align: center;
      color: #999999; /* 提示文字颜色可配置 */
      font-size: 13px; /* 提示文字大小可配置 */
      letter-spacing: 1px;
      line-height: 1.5;
      margin-top: 15px;
      width: 100%;
      overflow-wrap: break-word;
    }
  }
}
</style>
